// extracted by mini-css-extract-plugin
export var advantages = "advantageProductSection-module--advantages--c3b3b";
export var content3 = "advantageProductSection-module--content3--09587";
export var content4 = "advantageProductSection-module--content4--cefe5";
export var image = "advantageProductSection-module--image--b6bc3";
export var overlay = "advantageProductSection-module--overlay--da336";
export var text = "advantageProductSection-module--text--7012c";
export var title = "advantageProductSection-module--title--982cf";
export var wrapper = "advantageProductSection-module--wrapper--a1a71";